<template>
  <div class="membership">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.showMembership') }}
        </h3>
      </div>
      <div class="box-body">
        <form-membership :editable="false" />
      </div>
    </div>
  </div>
</template>

<script>
import FormMembership from './Form'
export default {
  name: 'Show',
  components: { FormMembership },
  metaInfo () {
    return {
      title: this.$t('string.showMembership'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
